import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ErrorTryCatch from 'components/consumer/error-try-catch';
import classNames from 'classnames';
import MixedGridCard from './MixedGridCard';
import MixedGridCardPlaceholder from './MixedGridCardPlaceholder';

const MixedGridItemsWithReviews = ({
  loadingMore,
  data,
  hits,
  hoveredValue,
  layout,
  onHoverHandler,
  toggleModalView,
  isMixedGridTab,
  allStaticProductData = [],
}) => {
  const gridItems = useMemo(() => {
    const items = [];
    // remove review types and push after 2 of products / photos.
    const reviewsList = [];
    const nonReviewsList = [];
    data.forEach(each => {
      if (each.card_type === 'review') {
        reviewsList.push(each);
      } else {
        nonReviewsList.push(each);
      }
    });
    // push 2 of nonReviews type and 1 of reviews type.
    let i = 0;
    let j = 0;
    while (reviewsList[i] || nonReviewsList[j]) {
      if (nonReviewsList[j]) {
        if (nonReviewsList.length - j >= 2 && !!allStaticProductData.length) {
          const firstCard = nonReviewsList[j++];
          const secondCard = nonReviewsList[j++];
          const productData = allStaticProductData.find(
            product => parseInt(product.id, 10) === parseInt(firstCard.id, 10)
          );

          items.push(
            <div
              className={classNames(
                'grid gap-[10px] max-[767px]:mt-2 md:gap-4 min-[1200px]:grid-cols-[repeat(auto-fit,minmax(300px,33.333%))] max-[767px]:[&>*]:max-w-[100vw]',
                {
                  'xl:grid-cols-[repeat(auto-fit,minmax(45%,1fr))] xl:m-0': isMixedGridTab,
                }
              )}
              key={`$prodkey${j - 2}-photkey2${j - 1}`}
            >
              <ErrorTryCatch key={`$prodkey${j - 2}`}>
                {/* card_type === 'product' */}
                <MixedGridCard
                  {...firstCard}
                  index={j - 2}
                  hits={hits}
                  hoveredValue={hoveredValue}
                  layout={layout}
                  onHoverHandler={onHoverHandler}
                  toggleModalView={toggleModalView}
                  productData={productData}
                />
              </ErrorTryCatch>

              <ErrorTryCatch key={`photkey2${j - 1}`}>
                {/* card_type === 'customer_photo' */}
                <MixedGridCard
                  {...secondCard}
                  index={j - 1}
                  hits={hits}
                  hoveredValue={hoveredValue}
                  layout={layout}
                  onHoverHandler={onHoverHandler}
                  toggleModalView={toggleModalView}
                />
              </ErrorTryCatch>
            </div>
          );
        } else {
          items.push(
            <div
              className={classNames(
                'grid gap-[10px] max-[767px]:mt-2 md:gap-4 min-[1200px]:grid-cols-[repeat(auto-fit,minmax(300px,33.333%))] max-[767px]:[&>*]:max-w-[100vw]',
                {
                  'xl:grid-cols-[repeat(auto-fit,minmax(45%,1fr))] xl:m-0': isMixedGridTab,
                }
              )}
              key={`${nonReviewsList[j].id}key1`}
            >
              <ErrorTryCatch key={`${nonReviewsList[j].id}key1`}>
                {/* This component doesn't seem to ever be rendered */}
                <MixedGridCard
                  {...nonReviewsList[j++]}
                  index={j - 1}
                  hits={hits}
                  hoveredValue={hoveredValue}
                  layout={layout}
                  onHoverHandler={onHoverHandler}
                  toggleModalView={toggleModalView}
                />
              </ErrorTryCatch>
            </div>
          );
        }
      }
      if (reviewsList[i]) {
        const thirdCard = reviewsList[i++];
        items.push(
          <div className="flex flex-col" key={`${thirdCard.id}key3`}>
            <ErrorTryCatch key={`${thirdCard.id}key3`}>
              {/* card_type === 'review' */}
              <MixedGridCard
                {...thirdCard}
                index={i - 1}
                hits={hits}
                hoveredValue={hoveredValue}
                layout={layout}
                onHoverHandler={onHoverHandler}
                toggleModalView={toggleModalView}
              />
            </ErrorTryCatch>
          </div>
        );
      }
    }
    return items;
  }, [
    allStaticProductData,
    data,
    hits,
    hoveredValue,
    isMixedGridTab,
    layout,
    onHoverHandler,
    toggleModalView,
  ]);

  return (
    <>
      {gridItems} {loadingMore ? <MixedGridCardPlaceholder /> : null}
    </>
  );
};

MixedGridItemsWithReviews.propTypes = {
  allStaticProductData: PropTypes.array,
  data: PropTypes.array,
  from: PropTypes.string,
  gridWithOneCol: PropTypes.bool,
  gridWithReviews: PropTypes.bool,
  hits: PropTypes.number,
  hoveredValue: PropTypes.object,
  isMixedGridTab: PropTypes.bool,
  keyId: PropTypes.string,
  layout: PropTypes.string,
  loading: PropTypes.bool,
  loadMore: PropTypes.func,
  loadingMore: PropTypes.bool,
  maxCardsCount: PropTypes.number,
  onHoverHandler: PropTypes.func,
  toggleModalView: PropTypes.func,
};

export default MixedGridItemsWithReviews;
